import React, { forwardRef } from "react";
import { TutorialVideo, VideoSourceType } from "../types/tutorial-bank.types";

interface VideoPlayerProps {
  video: TutorialVideo;
  className?: string;
}

const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ video, className = "w-full h-full" }, ref) => {
    // Determine video type based on sourceType or URL pattern
    const isYoutubeOrVimeo =
      video.sourceType === VideoSourceType.YOUTUBE ||
      video.sourceType === VideoSourceType.VIMEO ||
      (video.url &&
        (video.url.includes("youtube.com/embed") ||
          video.url.includes("player.vimeo.com")));

    const isExternalVideo =
      video.sourceType === VideoSourceType.EXTERNAL ||
      (video.url &&
        (video.url.endsWith(".mp4") ||
          video.url.endsWith(".mov") ||
          video.url.endsWith(".webm") ||
          video.url.includes("cloudfront.net") ||
          video.url.includes("amazonaws.com")));

    if (isYoutubeOrVimeo) {
      return (
        <iframe
          src={video.url}
          title={video.title || "Video"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={className}
        ></iframe>
      );
    }

    // For both external videos and uploaded videos, use the video tag
    return (
      <video
        ref={ref}
        src={video.url}
        poster={video.thumbnailUrl}
        controls
        className={className}
      >
        Your browser does not support the video tag.
      </video>
    );
  }
);

VideoPlayer.displayName = "VideoPlayer";

export default VideoPlayer;
